module.exports = __webpack_public_path__ + "media/images/icon-svg/envelope-1090ae8953cccfe8b32de7c64ddb16b0.svg";